module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-3bc65cd22b83186b6531416bff48d747.jpg";